import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

const COLORS = ["#0d6efd", "#198754", "#ffc107", "#dc3545"];

const PaymentMethodChart = ({ data = [] }) => {
  const chartData = Array.isArray(data) ? data : [];

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-0">
        <h5 className="mb-0">Payments by Method</h5>
      </div>

      <div className="card-body">
        {chartData.length ? (
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>

              <Tooltip
                formatter={(value) =>
                  `\u20B9${Number(value).toLocaleString("en-IN")}`
                }
              />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div
            className="d-flex align-items-center justify-content-center text-muted"
            style={{ height: 320 }}
          >
            No payment method data available
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentMethodChart;
